module.exports = __webpack_public_path__ + "static/googlebooks-7f0cf3f683672affbfe683d1600930a8.png";